export const CARE_PATHWAY_CONSENT = {
  sectionTitle: 'Understanding Your Care Pathway',
  summary:
    'Our psychiatrists provide assessment and diagnosis only — not ongoing care. After your appointment, your GP manages medication prescribing, while Telecare\'s mental health clinicians are available for therapy and psychoeducation support.',
  acceptanceStatement:
    'I understand and accept the shared care model, prescribing arrangements, and scope of the Telecare service described above.',
} as const;
